// extracted by mini-css-extract-plugin
module.exports = {"table":"index_table_3Stzg","textDivider":"index_textDivider_1QjdL","textDividerContent":"index_textDividerContent_3FUcy"};